import { APP_URLS } from 'constants/urls';
import { BreadCrumbsOptions } from './types';
import getDashboardHomeItem from './dashboardHomeItem';

export default function getSsoBreadcrumbMap({
  pathname,
  t,
  entity,
}: BreadCrumbsOptions) {
  const dashboardHomeItem = getDashboardHomeItem({ t });
  const ssoItem = {
    label: t('single-sign-on-sso'),
    path: APP_URLS.dashboard.sso.index.getPathWithQuery(),
  };

  return [
    {
      condition: APP_URLS.dashboard.sso.index.isTheSameUrlAs(pathname),
      data: [dashboardHomeItem, { label: t('single-sign-on-sso') }],
    },
    {
      condition: APP_URLS.dashboard.sso.add.isTheSameUrlAs(pathname),
      data: [dashboardHomeItem, ssoItem, { label: t('add-sso-connection') }],
    },
    {
      condition: APP_URLS.dashboard.sso.edit.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [dashboardHomeItem, ssoItem, { label: t('edit-sso-connection') }],
    },
    {
      condition: APP_URLS.dashboard.sso.view.isTheSameUrlAs(pathname, {
        pathParts: {
          id: `${entity?.id}`,
        },
      }),
      data: [dashboardHomeItem, ssoItem, { label: t('view-sso-connection') }],
    },
  ];
}
